import React from "react";
// import ReactDOM from "react-dom"
// 放到苍穹页面直接使用
import { Provider } from "react-redux";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import * as ReactDom from "react-dom/client";
import App from "../src/components/app";
import { baseReducer } from "../src/store/reducer";
import { dataConversion } from "../src/components/util/util";
(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model);
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model;
        },
        init: function (props) {
            console.log("-----init", this.model.style, props)
            this.store = configureStore({
                reducer: baseReducer,
                middleware: (getDefaultMiddleware) =>
                    getDefaultMiddleware({
                        serializableCheck: {
                            ignoreActions: true,
                            ignoreState: true,
                        },
                    }),
            });
            KDApi.loadFile("./main.css", this.model, () => {
                ReactDom.createRoot(this.model.dom).render(
                    <Provider store={this.store}>
                        <App />
                    </Provider>
                );
            });
            this.model.invokeAsync("init", "init");
            this.store.dispatch({ type: "setEnvironment", payload: "online" });
            this.store.dispatch({
                type: "setModel",
                payload: {
                    invokeAsync: this.model.invokeAsync,
                },
            });
        },
        update: function (props) {
            console.log("-----update", this.model, props);
            if (props.data) {
                dataConversion(props.data, this.store);
            }
        },
        destoryed: function () {
            // this.store.dispatch({type: "TDAInit", payload: "TDAInit"})
            // ReactDOM.unmountComponentAtNode(this.model.dom)
            console.log("-----destoryed", this.model);
        },
    };

    // 注册自定义组件
    KDApi.register("ai-cvp-ocr-tie", MyComponent);
})(window.KDApi);

console.log("TDA: <<<<<<<<<<<<<<<<<<<<<<<SS_TIME_STAMP>>>>>>>>>>>>>>>>>>>>>");
